module.exports = __webpack_public_path__ + "img/SWS_collections_2022_56_web.6b949291.jpeg";